import { ReactNode, useRef } from "react";
import { Icon } from "../icons/icon";

export const Checkbox = ({
  checked = false,
  onCheck = () => {},
  onUnCheck = () => {},
  text,
  className = "",
  iconDim = 16,
}: {
  checked?: boolean;
  onCheck?: () => void;
  onUnCheck?: () => void;
  text?: ReactNode;
  className?: string;
  iconDim?: number;
}) => {
  const checkBoxRef = useRef<HTMLInputElement | null>(null);

  return (
    <button
      type="button"
      className={`w-fit text-left cursor-pointer flex gap-2 items-center ${className}`}
      onClick={() => {
        checkBoxRef?.current?.click();
      }}
    >
      <Icon
        svg={checked ? "checkbox-active" : "checkbox-inactive"}
        width={iconDim}
        height={iconDim}
        className="text-pry-green-200"
      />

      {text}

      <input
        type="checkbox"
        className="hidden"
        ref={checkBoxRef}
        checked={checked}
        onChange={() => {
          if (checked) {
            onUnCheck();
          } else {
            onCheck();
          }
        }}
      />
    </button>
  );
};
